export function employedOn(employment,profile,date){
 const periods=employment.filter(p=>p.profile_id===profile);
 return !periods.length||periods.some(p=>(!p.start_date||p.start_date<=date)&&(!p.end_date||p.end_date>=date));
}
export function employedDuring(employment,profile,start,end){
 const periods=employment.filter(p=>p.profile_id===profile);
 return !periods.length||periods.some(p=>(!p.start_date||p.start_date<=end)&&(!p.end_date||p.end_date>=start));
}
export function workPlanLabel(d){
 if(!d)return '';
 if(d.mode==='off')return 'Çalışma yok';
 const slots=d.slots||[];
 const evening=slots.length&&slots.every(s=>s.start>='17:00');
 const mixed=slots.length>1&&!evening&&slots.some(s=>s.start>='17:00');
 const type=evening?'Akşam':mixed?'Gündüz + akşam':d.mode==='flexible'?'Esnek':'Çalışma';
 const duration=d.hours??(slots.length?slots.reduce((sum,s)=>{const n=t=>Number(t.slice(0,2))*60+Number(t.slice(3));return sum+n(s.end)-n(s.start);},0)/60:null);
 return [type,duration!=null?duration+' sa':null].filter(Boolean).join(' · ');
}
